import styled, { css } from 'styled-components';

export const GroupItemMobileWrapper = styled.div<{ $isLoading?: boolean }>`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 6px;
    width: 72px;

    ${({ $isLoading }) =>
        $isLoading &&
        css`
            pointer-events: none;
            opacity: 0.5;
        `};
`;

export const GroupItemMobileName = styled.div`
    font-weight: 500;
    font-size: 10px;
    line-height: 100%;
    text-align: center;
    letter-spacing: -0.02em;
    color: #ffffff;
    width: 100%;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;
